import DatatablesController from '../../../datatables_controller';

export default class extends DatatablesController {
  initialize(){
    super.initialize();
    this.filter = document.querySelector('[data-controller="admin--index-filter"]');
    this.filterTriggerer = this.filter.querySelector('[data-admin--index-filter-target="filterTriggerer"]');
  }

  connect(){
    super.connect();
    // this.bindChangeDateFilter();
    this.bindFilter();
  }

  bindFilter(){
    this.filterTriggerer.addEventListener('click', (e) => {
      window.KTApp.blockPage();
      const params = [];

      const inputs = this.filter.querySelectorAll('input,select');
      for(let i=0 ;i<inputs.length; i++){
        if(inputs[i].type === 'radio'){
          if(inputs[i].checked){
            params.push({
              name: inputs[i].name,
              value: inputs[i].value
            });
          }
        } else if(inputs[i].tagName === 'SELECT'){
          if(inputs[i].hasAttribute('multiple')){
            const selectedValues = Array.prototype.slice.call(
              inputs[i].selectedOptions
            ).map((x) => {return x.value});
            params.push({
              name: inputs[i].name,
              value: selectedValues
            });
          } else {
            const selectedOption = inputs[i].selectedOptions[0]
            if(selectedOption){
              params.push({
                name: inputs[i].name,
                value: selectedOption.value
              });
            }
          }
        } else if(inputs[i].type === 'checkbox'){
          if(!inputs[i].checked){
            continue;
          }

          const a = params.filter((x) => {return x.name == inputs[i].name})[0]
          if(a){
            a.value.push(inputs[i].value);
          } else {
            params.push({
              name: inputs[i].name,
              value: [inputs[i].value]
            });
          }

        } else {
          params.push({
            name: inputs[i].name,
            value: inputs[i].value
          });
        }
      }

      if(params.length > 0){
        params.forEach((entry) => {
          this.datatable.setDataSourceParam(entry.name, entry.value);
          this.datatable.load();
        });
      }

      window.KTApp.unblockPage();
      this.filter.click();
    });
  }

  // bindChangeDateFilter(){
    // $('#kt_dashboard_datepicker_custom').on('change', function(e) {
      // this.datatable.setDataSourceParam('date', e.currentTarget.value);
      // this.datatable.load();
    // }.bind(this));
  // }

  datatableColumns(){
    return [
      {
        field: 'index',
        title: 'No',
        sortable: false,
        width: 25,
        type: 'number',
        selector: false,
        textAlign: 'left',
        overflow: 'visible',
        autoHide: false,
        template: function(data) {
          return `<span class="font-weight-bolder">${data.index}</span>`;
        }
      },
      {
        field: 'user.name',
        title: 'Nama',
        overflow: 'visible',
        autoHide: false,
        width: 200,
        template: function(data) {
          return `
            <div class="d-flex align-items-center">
              <div class="symbol symbol-50 flex-shrink-0 mr-4">
                <div
                  class="symbol-label"
                  style="background-image: url('${data.avatar_path}')"
                ></div>
              </div>
              <div style="overflow-wrap:anywhere;">
                <a
                  href="javascript:void(0);"
                  class="d-block text-dark-75 font-weight-bolder text-hover-primary mb-1"
                >${data.name}</a>
                <span class="text-muted font-weight-bold ">${data.email}</span>
              </div>
            </div>
          `;
        }
      },
      {
        field: 'created_at',
        title: 'Bergabung',
        overflow: 'visible',
        autoHide: false,
        template: function(data) {
          return `<span class="font-weight-bolder">${data.created_at}</span>`;
        }
      },
      {
        field: 'refer_count',
        title: 'Jumlah refer',
        overflow: 'visible',
        autoHide: false,
        sortable: false,
        template: function(data) {
          return `<span class="font-weight-bolder">${data.refer_count}</span>`;
        }
      },
      {
        field: 'balance',
        title: 'Saldo',
        overflow: 'visible',
        autoHide: false,
        template: function(data) {
          return `<span class="font-weight-bolder">${data.balance}</span>`;
        }
      },
      {
        field: 'total_comission',
        title: 'Total komisi',
        sortable: false,
        overflow: 'visible',
        autoHide: false,
        template: function(data) {
          return `<span class="font-weight-bolder">${data.total_comission}</span>`;
        }
      },
      {
        field: 'total_withdrawal',
        title: 'Total Penarikan',
        sortable: false,
        overflow: 'visible',
        autoHide: false,
        template: function(data) {
          return `
            <div class="d-flex align-items-center">
              <div>
                <a
                  href="#"
                  class="text-dark-75 font-weight-bolder text-hover-primary mb-1"
                >${data.total_withdrawal}</a>
                <span class="text-muted font-weight-bold d-block">Pending: ${data.total_withdrawal_pending}</span>
              </div>
            </div>
          `;
        }
      },
      {
        field: 'Actions',
        title: 'Actions',
        sortable: false,
        width: 120,
        overflow: 'visible',
        autoHide: false,
        template: function(data) {
          return `
            <a class="btn btn-sm btn-clean btn-icon" href="${data.show_path}" title="Tampilkan">
              <i class="fa fa-eye text-primary"></i>
            </a>
          `;
        },
      }
    ]
  }
}
